import * as React from "react";
import { forwardRef } from "react";
const SvgA1 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 179.68 180", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, "\n      .cls-1 {\n        fill: #203b5e;\n        fill-rule: evenodd;\n      }\n    ")), /* @__PURE__ */ React.createElement("path", { className: "cls-1", d: "M103.87,2.36h-28.05L0,178.62h31c30.05-71.61,26.16-63.35,58.33-139.47,31.42,73.8,28.62,67.52,58.36,139.47h31.98L103.87,2.36Z" }));
const ForwardRef = forwardRef(SvgA1);
export { ForwardRef as ReactComponent };
